import { ANONYMOUS_CONVERSATION_NAME } from "@/pages/Chat/components/ChatBubble/constants";

export const replaceMessageTokens = (string, { characterName = "", userName = ANONYMOUS_CONVERSATION_NAME }) => {
  if (!string) {
    return string;
  }
  return string.replaceAll(/{{char}}|<BOT>/gi, characterName).replaceAll(/{{user}}|<USER>/gi, userName);
};
